<template>
  <div
    v-if="isValid"
    class="smart-coupon-container item-print"
    :class="printMode"
    style="display: block; color: #000000"
  >
    <div
      v-if="printMode === 'K80'"
      style="
        padding-top: 10px;
        border-bottom: 1px dashed black;
        padding-bottom: 15px;
      "
    >
      <div style="border-top: 2px dashed black; padding-top: 10px"></div>

      <h6
        class="text-center"
        style="font-size: 16px; font-weight: bold; margin-bottom: 4px"
      >
        COUPON TRỊ GIÁ 500.000Đ
      </h6>
      <p
        class="text-center"
        style="font-size: 14px; margin-bottom: 12px"
      >
        Giảm 500.000đ khi mua Smartwatch từ 5 triệu (trừ Apple, Samsung)
      </p>

      <h6
        class="text-center"
        style="font-size: 16px; font-weight: bold; margin-bottom: 4px"
      >
        COUPON TRỊ GIÁ 100.000Đ
      </h6>
      <p
        class="text-center"
        style="font-size: 14px; margin-bottom: 12px"
      >
        Giảm 100.000đ khi mua đồng hồ trẻ em (myAlo, Huawei)
      </p>

      <div style="border-top: 1px dashed black; margin: 8px 0 12px"></div>

      <div style="font-size: 14px; line-height: 1.5">
        <p style="font-weight: bold; margin-bottom: 4px">Điều kiện sử dụng:</p>
        <p style="margin: 0 0 12px 0; padding-left: 14px; text-indent: -14px">
          • Không áp dụng đồng thời CTKM và phiếu mua hàng cùng loại khác
        </p>

        <p style="font-weight: bold; margin-bottom: 4px">Thời gian áp dụng:</p>
        <p style="margin-bottom: 10px">Từ 01/05 - 31/05</p>

        <p style="margin-bottom: 8px">Áp dụng toàn hệ thống DDV toàn quốc</p>
        <br />
        <p style="font-style: italic">
          Khách hàng có thể liên hệ hotline 18006018 (miễn phí) hoặc nhân viên
          tại cửa hàng để được hỗ trợ.
        </p>
      </div>
    </div>

    <div
      v-if="printMode === 'A4'"
      style="
        page-break-before: always;
        border-top: 2px dashed black;
        padding-top: 20px;
        margin-top: 20px;
        text-align: left;
        width: 100%;
        border-bottom: 2px dashed black;
        padding-bottom: 20px;
      "
    >
      <h6
        class="text-center"
        style="font-size: 22px; font-weight: bold; margin-bottom: 6px"
      >
        COUPON TRỊ GIÁ 500.000Đ
      </h6>
      <p
        class="text-center"
        style="font-size: 18px; margin-bottom: 16px"
      >
        Giảm 500.000đ khi mua Smartwatch từ 5 triệu (trừ Apple, Samsung)
      </p>

      <h6
        class="text-center"
        style="font-size: 22px; font-weight: bold; margin-bottom: 6px"
      >
        COUPON TRỊ GIÁ 100.000Đ
      </h6>
      <p
        class="text-center"
        style="font-size: 18px; margin-bottom: 16px"
      >
        Giảm 100.000đ khi mua đồng hồ trẻ em (myAlo, Huawei)
      </p>

      <div style="border-top: 1px dashed black; margin: 12px 0 16px"></div>

      <div style="font-size: 18px; line-height: 1.5">
        <p style="font-weight: bold; margin-bottom: 6px">Điều kiện sử dụng:</p>
        <p style="margin: 0 0 16px 0; padding-left: 18px; text-indent: -18px">
          • Không áp dụng đồng thời CTKM và phiếu mua hàng cùng loại khác
        </p>

        <p style="font-weight: bold; margin-bottom: 6px">Thời gian áp dụng:</p>
        <p style="margin-bottom: 12px">Từ 01/05 - 31/05</p>

        <p style="margin-bottom: 8px">Áp dụng toàn hệ thống DDV toàn quốc</p>
        <p style="margin-bottom: 0">Hotline hỗ trợ: 18000618</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bill: {
      type: Object,
      required: true,
    },
    printMode: {
      type: String,
      default: 'K80',
    },
  },
  data() {
    return {
      listCategoryDisplay: [480192, 480193, 480194, 480195, 480198, 480199, 534102, 480200, 534302, 534303, 534342,
        480201, 480202, 533933, 533934, 533935, 533936, 533937, 533938, 533977, 533978,
        480208, 480209, 480210, 533959, 480312, 480313, 480314, 480315, 480316, 480317, 480318, 480319, 480320,
        480321, 480323, 533939, 533940, 533941, 533942, 533943, 533944,
        533859, 533860, 533861, 533863, 533871, 533872, 533873
      ]
    };
  },
  computed: {
    isValid() {
      if (!this.bill) return false;
      const isDDV = this.bill.storeName && this.bill.storeName.includes('DDV');
      const items = Array.isArray(this.bill.listBillItem) ? this.bill.listBillItem : [];
      const hasMatchedCategory = items.some(
        (item) => this.listCategoryDisplay.includes(item.productCategory),
      );
      return isDDV && hasMatchedCategory;
    },
  },
};
</script>
<style scoped>
p {
  margin-bottom: 0.5rem;
}
ul {
  margin-bottom: 0.5rem;
}
</style>
